import React, { ElementType, MouseEventHandler, ReactNode } from 'react'
import { CardActionArea as MuiCardActionArea } from '@mui/material'

import LinkWrapper from 'components_new/atoms/LinkWrapper'

interface CardActionAreaProps {
  children: ReactNode
  component?: ElementType<any>
  disabled?: boolean
  disableRipple?: boolean
  href?: string
  newTab?: boolean
  onContextMenu?: (() => void) | MouseEventHandler<HTMLElement>
  onClick?: (() => void) | MouseEventHandler<HTMLElement>
  onMouseDown?: (() => void) | MouseEventHandler<HTMLElement>
  search?: string
  sx?: object
  to?: string
}

/**
 * The action area (read: Button) of a Card can
 * be specified by wrapping its contents in a
 * CardActionArea component.
 *
 * This should be used for the main action
 * action of a Card making the whole (or part of
 * the-) surface clickable.
 *
 * @requires Card component.
 */

const CardActionArea = React.forwardRef(
  (props: CardActionAreaProps, ref: any) => {
    const { children, disabled, href, newTab, search, ...rest } = props

    return (
      <LinkWrapper
        disabled={disabled}
        href={href}
        newTab={newTab}
        search={search}
        style={{ width: '100%' }}
      >
        <MuiCardActionArea disabled={disabled} {...rest} ref={ref}>
          {children}
        </MuiCardActionArea>
      </LinkWrapper>
    )
  }
)

CardActionArea.displayName = 'CardActionArea'
export default CardActionArea
